export function isUrl(url: string) {
  const allowedSchemes = ['http:', 'https:', 'mailto:', 'tel:'];
  try {
    const parsedUrl = new URL(url);
    return allowedSchemes.includes(parsedUrl.protocol);
  } catch (e) {
    return false;
  }
}
